var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetroCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.326,
    height: 38.326,
    viewBox: "0 0 38.326 38.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cross",
    "data-name": "Icon metro-cross",
    d: "M40.547,32.718h0L28.92,21.091,40.547,9.464h0a1.2,1.2,0,0,0,0-1.693L35.055,2.278a1.2,1.2,0,0,0-1.693,0h0L21.734,13.9,10.107,2.278h0a1.2,1.2,0,0,0-1.693,0L2.921,7.77a1.2,1.2,0,0,0,0,1.693h0L14.548,21.091,2.921,32.718h0a1.2,1.2,0,0,0,0,1.693L8.413,39.9a1.2,1.2,0,0,0,1.693,0h0L21.734,28.277,33.361,39.9h0a1.2,1.2,0,0,0,1.693,0l5.492-5.492a1.2,1.2,0,0,0,0-1.693Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#06d554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroCross);
export default __webpack_public_path__ + "static/media/metro-cross.4e851fc577455eae418b3494c2c8c2b6.svg";
export { ForwardRef as ReactComponent };